import { AfterContentInit, Component, ContentChild, ElementRef, Input, ViewChild, ViewEncapsulation } from '@angular/core';

import { PuiPortletHeaderComponent } from './portlet-header.component';
import { PuiPortletBodyComponent } from './portlet-body.component';
import { PuiTabComponent } from '../tab/index';

let nextId = 0;

@Component({
  selector: 'pui-portlet',
  templateUrl: 'portlet.component.html',
  styleUrls: ['portlet.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PuiPortletComponent implements AfterContentInit {
  @Input() id = `pui-portlet-${nextId++}`;
  // @Input('has-form') hasForm: boolean = false;
  // @Input('options') options: {} = {};
  @ContentChild(PuiPortletHeaderComponent) header: PuiPortletHeaderComponent;
  @ContentChild(PuiPortletBodyComponent) body: PuiPortletBodyComponent;
  @ViewChild('body') bodyRef: ElementRef;
  hasTabs = false;
  tabs: Array<PuiTabComponent> = [];

  ngAfterContentInit() {
    if (this.body && this.body.tabset && this.body.tabset.attachedPortlet) {
      if (this.body.tabset.tabs) {
        this.header.tabset = this.body.tabset;
        this.hasTabs = true;
      }
    }
  }
}
